<template>
    <div class="container-fluid" style="background-color: white">
        <br>
        <h2 class="text-center">วิธีการชำระเงิน</h2>
        <div class="row">
            <div class="col offset-sm-6 col-sm-6">
                <div class="row form-group">
                    <div class="col col-6">
                        <label class="col-form-label text-right">ยอดที่ต้องชำระ</label>
                    </div>
                    <div class="col col-6">
                        <label class="col-form-label">
                            <strong>
                                {{ form.total_amount | currency }}
                            </strong>
                        </label>
                    </div>
                </div>
            </div>

            <div class="col offset-sm-6 col-sm-6">
                <div class="row form-group">
                    <div class="col col-6">
                        <label class="col-form-label text-right">หักภาษี ณ ที่จ่าย</label>
                    </div>
                    <div class="col col-6">
                        <b-form-select v-model="form.calc_tax"
                                       :options="taxOptions">
                        </b-form-select>
                    </div>
                </div>
            </div>
        </div>
        <!-- Cash -->
        <div class="form-group row">
            <div class="col pl-5">
                <input class="form-check-input"
                       type="checkbox"
                       id="type-cash"
                       v-model="transaction.checkCash"/>
                <label class="form-check-label" for="type-cash">
                    เงินสด
                </label>
            </div>
            <template v-if="transaction.checkCash">
                <div class="col">
                    <input type="number"
                           placeholder="จำนวนเงิน"
                           class="form-control"
                           v-model="transaction.cash.amount"
                           step="0.01"/>
                </div>
            </template>
        </div>
        <hr>
        <!-- Cheque -->
        <div class="form-group row">
            <div class="col pl-5">
                <input class="form-check-input"
                       type="checkbox"
                       id="type-cheque"
                       v-model="transaction.checkCheque"/>
                <label class="form-check-label" for="type-cheque">
                    เช็ค
                </label>
            </div>
        </div>
        <template v-if="transaction.checkCheque">
            <template v-for="(data,index) in transaction.cheque">
                <div class="form-group row">
                    <div class="col" :for="`ref_no${index}`">
                        <input type="text"
                               :id="`ref_no${index}`"
                               placeholder="หมายเลขเช็ค"
                               v-model="data.ref_no"
                               class="form-control"/>
                    </div>
                    <div class="col" :for="`date${index}`">
                        <date-picker
                            :id="`date${index}`"
                            v-model="data.date"
                            class="w-100"
                            :format="changeFormat"
                            :lang="lang"
                            confirm
                            placeholder="ลงวันที่">
                        </date-picker>
                    </div>
                    <div class="col" :for="`bank_name${index}`">
                        <multiselect
                            v-model="data.bank"
                            :options="optionBank"
                            :id="`date${index}`"
                            :customLabel="customLabelBank"
                            :show-labels="false"
                            placeholder="เลขบัญชีธนาคาร"
                            track-by="id">
                        </multiselect>
                    </div>
                    <div class="col" :for="`bank_branch${index}`" v-if="data.bank">
                        <input type="text"
                               disabled
                               :id="`bank_branch${index}`"
                               placeholder="สาขา"
                               v-model="data.bank.branch_id"
                               class="form-control"/>
                    </div>
                    <div class="col" :for="`amount${index}`">
                        <input type="number"
                               :id="`amount${index}`"
                               placeholder="จำนวนเงิน"
                               v-model="data.amount"
                               class="form-control"
                               step="0.01"/>
                    </div>
                    <div class="col flex-grow-0">
                        <button class="btn btn-primary" @click="addCheque"
                                v-if="(index + 1) === transaction.cheque.length">
                            <icon name="plus"></icon>
                        </button>
                        <button class="btn btn-danger" v-if="(index + 1) < transaction.cheque.length"
                                @click="removeCheque(index)">
                            <icon name="minus"></icon>
                        </button>
                    </div>
                </div>
            </template>
            <!--<div class="row">-->
            <!--<div class="col">-->
            <!--<button class="btn btn-primary" @click="addCheque">-->
            <!--<icon name="plus"></icon>-->
            <!--เพิ่มรายการ-->
            <!--</button>-->
            <!--</div>-->
            <!--<div class="col">-->
            <!--<div class="row">-->
            <!--<div class="col col-6 text-right">-->
            <!--<label class="col-form-label">-->
            <!--<strong>รวม</strong>-->
            <!--</label>-->
            <!--</div>-->
            <!--<div class="col col-6">-->
            <!--<label class="col-form-label">-->
            <!--<strong>-->
            <!--{{ 0.00 | currency }}-->
            <!--</strong>-->
            <!--</label>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
        </template>
        <hr>
        <!-- Transfer -->
        <div class="form-group row">
            <div class="col pl-5">
                <input class="form-check-input"
                       type="checkbox"
                       id="type-transfer"
                       v-model="transaction.checkTransfer">
                <label class="form-check-label" for="type-transfer">
                    เงินโอน
                </label>
            </div>
        </div>
        <template v-if="transaction.checkTransfer">
            <template v-for="(data,index) in transaction.transfer ">
                <div class="form-group row">
                    <div class="col" :for="`ref_no${index}`">
                        <multiselect
                            v-model="data.bank"
                            :options="optionBank"
                            id="`ref_no${index}`"
                            :customLabel="customLabelBank"
                            :show-labels="false"
                            placeholder="เลขบัญชีธนาคาร"
                            track-by="id">
                        </multiselect>
                    </div>
                    <div class="col" :for="`date${index}`">
                        <date-picker
                            :id="`date${index}`"
                            class="w-100"
                            :format="changeFormat"
                            :lang="lang"
                            confirm
                            v-model="data.date"
                            placeholder="ลงวันที่">
                        </date-picker>
                    </div>
                    <div class="col" :for="`amount${index}`">
                        <input type="number"
                               :id="`amount${index}`"
                               placeholder="จำนวนเงิน"
                               v-model="data.amount"
                               class="form-control"
                               step="0.01"/>
                    </div>
                    <div class="col flex-grow-0">
                        <button class="btn btn-primary" @click="addTransfer"
                                v-if="(index + 1) === transaction.transfer.length">
                            <icon name="plus"></icon>
                        </button>
                        <button class="btn btn-danger" v-if="(index + 1) < transaction.transfer.length"
                                @click="removeTransfer(index)">
                            <icon name="minus"></icon>
                        </button>
                    </div>
                </div>
            </template>
            <!--<div class="row">-->
            <!--<div class="col">-->
            <!--<button class="btn btn-primary" @click="addTransfer">-->
            <!--<icon name="plus"></icon>-->
            <!--เพิ่มรายการ-->
            <!--</button>-->
            <!--</div>-->
            <!--<div class="col">-->
            <!--<div class="row">-->
            <!--<div class="col col-6 text-right">-->
            <!--<label class="col-form-label">-->
            <!--<strong>รวม</strong>-->
            <!--</label>-->
            <!--</div>-->
            <!--<div class="col col-6">-->
            <!--<label class="col-form-label">-->
            <!--<strong>-->
            <!--{{ 0.00 | currency }}-->
            <!--</strong>-->
            <!--</label>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
        </template>
        <hr>
        <!-- Fee, offset, and pledge. -->
        <div class="row">
            <div class="col col-sm-6">
                <div class="row form-group">
                    <div class="col col-6">
                        <label class="col-form-label text-right">จ่ายเงิน เกิน</label>
                    </div>
                    <div class="col col-6">
                        <input type="number"
                               placeholder="รับเงิน เกิน"
                               class="form-control"
                               v-model="form.overpay"
                               step="0.01"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col col-6">
                        <label class="col-form-label text-right">จ่ายเงิน ขาด</label>
                    </div>
                    <div class="col col-6">
                        <input type="number"
                               placeholder="รับเงิน ขาด"
                               class="form-control"
                               v-model="form.arrears"
                               step="0.01"/>
                    </div>
                </div>
                <!--<div class="row form-group">-->
                <!--<div class="col col-6">-->
                <!--<label class="col-form-label text-right">ชำระด้วยเงินมัดจำ</label>-->
                <!--</div>-->
                <!--<div class="col col-6">-->
                <!--<input type="number"-->
                <!--placeholder="ชำระด้วยเงินมัดจำ"-->
                <!--v-model="form.pledge_amount"-->
                <!--class="form-control"-->
                <!--step="0.01">-->
                <!--</div>-->
                <!--</div>-->
            </div>

            <!--<div class="col col-sm-6">-->
            <!--<div class="row form-group">-->
            <!--<div class="col col-6">-->
            <!--<label class="col-form-label text-right">Fee/ค่าธรรมเนียม</label>-->
            <!--</div>-->
            <!--<div class="col col-6">-->
            <!--<input type="number"-->
            <!--placeholder="Fee/ค่าธรรมเนียม"-->
            <!--v-model="form.fee_amount"-->
            <!--class="form-control"-->
            <!--step="0.01">-->
            <!--</div>-->
            <!--</div>-->
            <!--<div class="row form-group">-->
            <!--<div class="col pl-5">-->
            <!--<label class="form-check-label" for="radio-sale">-->
            <!--<input class="form-check-input"-->
            <!--type="radio"-->
            <!--name="feePayer"-->
            <!--id="radio-sale"-->
            <!--value="sale" checked>-->
            <!--เซลล์-->
            <!--</label>-->
            <!--</div>-->
            <!--<div class="col pl-5">-->
            <!--<label class="form-check-label" for="radio-customer">-->
            <!--<input class="form-check-input"-->
            <!--type="radio"-->
            <!--name="feePayer"-->
            <!--id="radio-customer"-->
            <!--value="customer" checked>-->
            <!--ลูกค้า-->
            <!--</label>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
        </div>
        <hr>
        <!-- Summary -->
        <div class="form-group row">
            <div class="col col-sm-6">
                <label>
                    ยอดที่ต้องชำระ
                </label>
                <h2 class="form-control-plaintext">
                    {{ calculateTransaction > 0 ? form.total_amount - calculateTransaction : 0 | currency }}
                </h2>
            </div>
            <div class="col col-sm-6 text-right">
                <label>
                    รวมยอดเงินที่ชำระ
                </label>
                <h2 class="form-control-plaintext">
                    {{ calculateTransaction > 0 ? calculateTransaction : 0 | currency }}</h2>
            </div>
        </div>
        <div class="col text-center" v-if="form.status !== 2">
            <button @click="submitBillingPayoff"
                    type="button"
                    class="btn btn-success">
                <icon name="save"></icon>
                บันทึก
            </button>
            &nbsp&nbsp
            <button @click="cancelSubmit"
                    type="button"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon>
                ยกเลิก
            </button>
        </div>
        <br>
        <!--<pre class="alert alert-primary">{{ form }}</pre>-->
        <!--<pre class="alert-danger">{{form}}</pre>-->

    </div>
</template>

<script>
import {mapState} from "vuex"
import Multiselect from "vue-multiselect"
import DatePicker from "vue2-datepicker"
import moment from "moment"

export default {
    name: "rr-payoff-transaction",
    components: {
        DatePicker,
        Multiselect
    },
    created() {
        this.$store.dispatch("Common/getBankType");
        this.$store.dispatch("Bank/getBankAll")
    },
    data() {
        return {
            taxOptions: [
                {
                    text: '0%',
                    value: 0
                },
                {
                    text: '7%',
                    value: 1
                },
            ],
            optionBankType: state => {
                return [
                    {
                        value: null,
                        text: "เลือกธนาคาร"
                    },
                    ...state.Common.bank_type.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    computed: {
        ...mapState({
            form: state => {
                return state.RRPayoff.form
            },
            transaction: state => {
                return state.RRPayoff.transactions
            },
            optionBank: state => {
                return state.Bank.bank_all;
            }
        }),
        calculateTransaction() {
            let sum_amount = 0;
            let transactions = [];
            //เงินสด
            if (this.transaction.checkCash) {
                if (this.transaction.cash.amount) {
                    transactions.push(this.transaction.cash);
                }
            }
            //เช็ค
            if (this.transaction.checkCheque) {
                this.transaction.cheque.forEach(cheque => {
                    if (cheque.ref_no && cheque.bank) {
                        cheque.bank_name = cheque.bank.account_name;
                        cheque.bank_id = cheque.bank.id;
                        cheque.bank_branch = cheque.bank.branch_id;
                        if (!cheque.date) {
                            const currentDate = moment().format("YYYY-MM-DD");
                            cheque.date = currentDate;
                        } else {
                            cheque.date = moment(cheque.date).format("YYYY-MM-DD")
                            let date_year = moment(cheque.date).format('YYYY'); //get year
                            if (date_year <= 2000) {
                                let current_year = moment().format("YYYY");
                                cheque.date = moment(cheque.date).format(+current_year + "-MM-DD")
                            }
                        }
                        if (!cheque.amount) {
                            cheque.amount = "";
                        }
                        transactions.push(cheque);
                    }
                })
            }
            //เงินโอน
            if (this.transaction.checkTransfer) {
                this.transaction.transfer.forEach(transfer => {
                    if (transfer.bank) {
                        transfer.bank_id = transfer.bank.id;
                        if (!transfer.date) {
                            let currentDate = moment().format("YYYY-MM-DD");
                            transfer.date = currentDate;
                        } else {
                            transfer.date = moment(transfer.date).format("YYYY-MM-DD")
                            let date_year = moment(transfer.date).format('YYYY'); //get year
                            if (date_year <= 2000) {
                                let current_year = moment().format("YYYY");
                                transfer.date = moment(transfer.date).format(+current_year + "-MM-DD")
                            }
                        }
                        if (!transfer.amount) {
                            transfer.amount = "";
                        }
                        transactions.push(transfer);
                    }
                });
            }
            let price = 0;
            sum_amount = transactions.reduce((carry, detail) => {
                if (detail.amount) {
                    price = detail.amount
                } else {
                    price = 0;
                }
                return carry + parseFloat(price);
            }, 0);

            if (this.form.overpay) { //เงินเกิน
                sum_amount = sum_amount - parseFloat(this.form.overpay);
            }
            if (this.form.arrears) { //เงินขาด
                sum_amount = sum_amount + parseFloat(this.form.arrears);
            }
            return parseFloat(sum_amount).toFixed(2);
        }
    },
    methods: {
        customLabelBank(option) {
            return `${option.account_number} - ${option.name}`
        },
        submitBillingPayoff() {
            this.form.transactions = [];
            if (this.transaction.checkCash) {
                if (this.transaction.cash.amount) {
                    this.transaction.cash.amount = parseFloat(this.transaction.cash.amount);
                    this.form.transactions.push(this.transaction.cash);
                }
            }
            if (this.transaction.checkCheque) {
                this.transaction.cheque.forEach(cheque => {
                    if (cheque.ref_no && cheque.bank_name) {
                        if (!cheque.date) {
                            const currentDate = moment().format("YYYY-MM-DD");
                            cheque.date = currentDate;
                        } else {
                            cheque.date = moment(cheque.date).format("YYYY-MM-DD")
                        }
                        if (!cheque.amount) {
                            cheque.amount = "";
                        } else {
                            cheque.amount = parseFloat(cheque.amount);
                        }
                        this.form.transactions.push(cheque);
                    }
                });
            }
            if (this.transaction.checkTransfer) {
                this.transaction.transfer.forEach(transfer => {
                    if (transfer.bank) {
                        transfer.bank_id = transfer.bank.id;
                        if (!transfer.date) {
                            const currentDate = moment().format("YYYY-MM-DD");
                            transfer.date = currentDate;
                        } else {
                            transfer.date = moment(transfer.date).format("YYYY-MM-DD")
                        }
                        if (!transfer.amount) {
                            transfer.amount = "";
                        } else {
                            transfer.amount = parseFloat(transfer.amount);
                        }
                        this.form.transactions.push(transfer);
                    }
                });
            }
            if (this.form.total_amount != this.calculateTransaction) {
                alert("ยอดชำระไม่ถูกต้อง")
            } else {
                this.$emit('submit', true)
            }
        },
        cancelSubmit() {
            this.$emit('submit', false)
        },
        addCheque() {
            this.transaction.cheque = [
                ...this.transaction.cheque,
                {
                    transaction_type_id: 1,
                    ref_no: "",
                    date: "",
                    bank_name: "",
                    bank_branch: "",
                    amount: "",
                    description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                    bank_id: "",
                    bank: null,
                }
            ]
        },
        addTransfer() {
            this.transaction.transfer = [
                ...this.transaction.transfer,
                {
                    transaction_type_id: 2,
                    ref_no: "",
                    date: "",
                    bank_name: "",
                    bank_branch: "",
                    amount: "",
                    description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                    bank_id: "",
                    bank: null,
                }
            ]
        },
        removeCheque(index) {
            this.transaction.cheque = this.transaction.cheque.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        },
        removeTransfer(index) {
            this.transaction.transfer = this.transaction.transfer.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        }
    }
}
</script>

<style scoped>

</style>
